/* eslint-disable camelcase */
import React from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { array, object, string } from "prop-types";
import { HeroStory } from "./HeroStory";
import { OtherStory } from "./OtherStory";
import { useDeviceType } from "../../custom-hooks/useDeviceType";
import { isCollectionEmpty } from "../../utils/collection";
import { DfpComponent } from "../../ads/dfp-component";
import CollectionTitle from "../../atoms/CollectionTitle";
import { RowSeparator } from "../../atoms/RowSeparator";

import "./four-col-five-stories-wide-hero.m.css";

export const FourColFiveStoriesWideHero = ({ collection, stories, extraProp = "" }) => {
  const {
    show_row_separator,
    show_column_separator,
    show_story_separator,
    show_timestamp,
    show_read_time,
    enable_row_ad_slot,
    enable_sponsor_ad,
    sponsor_ad_details,
    show_row_ad_unit,
    show_row_ad_unit_bottom,
  } = get(collection, ["associated-metadata"], {});

  const rowAd = show_row_ad_unit?.split("/").slice(-1)[0];
  const rowAdDivId = useSelector((state) => get(state, ["qt", "config", "ads-config", "ad_div_mapping", rowAd], ""));

  const rowAdBottom = show_row_ad_unit_bottom?.split("/").slice(-1)[0];
  const rowAdBottomDivId = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "ad_div_mapping", rowAdBottom], "")
  );

  const pageType = useSelector((state) => get(state, ["qt", "pageType"], null));
  const filteredCollection = get(collection, ["items"], []).filter((collections) => collections.type === "collection");
  const device = useDeviceType();
  const [firstCollection = {}, secondCollection = {}] = filteredCollection.slice(0, 2).map((collection) => {
    const isStoriesCollection = get(collection, ["items"], []).every((item) => item.type === "story");
    return isStoriesCollection ? collection : {};
  });

  const sectionSlug = extraProp;

  if (isCollectionEmpty(firstCollection) && isCollectionEmpty(secondCollection)) {
    return null;
  }
  return (
    <div className="row-component">
      <div styleName="four-col-five-stories-wide-hero">
        <div styleName="collections-container">
          <div styleName="first-collection" style={{ borderRight: show_column_separator || "none" }}>
            <div styleName="row-title">
              <CollectionTitle
                collection={firstCollection}
                enableSponsorAd={enable_sponsor_ad}
                sponsorAdDetails={sponsor_ad_details}
                sectionSlug={sectionSlug}
              />
            </div>
            {!isCollectionEmpty(firstCollection) && (
              <div styleName="stories-container">
                <HeroStory
                  story={firstCollection?.items[0].story}
                  showStorySeparator={show_story_separator}
                  showSubheadline={device === "desktop"}
                  isFirstCollection={true}
                  showTimestamp={show_timestamp}
                  showReadTime={show_read_time}
                  sectionSlug={sectionSlug}
                />
                {firstCollection?.items.slice(1, 4).map(({ story }) => (
                  <OtherStory
                    key={story?.id}
                    story={story}
                    showStorySeparator={show_story_separator}
                    showTimestamp={show_timestamp}
                    showReadTime={show_read_time}
                    sectionSlug={sectionSlug}
                  />
                ))}
              </div>
            )}
          </div>
          {enable_row_ad_slot ? (
            <div styleName="second-collection-ad">
              <DfpComponent
                adStyleName="four-col-five-ad-slot-size-300x250"
                id={rowAdDivId}
                containerStyle={"fit-content"}
              />
            </div>
          ) : (
            !isCollectionEmpty(secondCollection) && (
              <div styleName="second-collection">
                <div styleName="row-title">
                  <CollectionTitle
                    collection={secondCollection}
                    enableSponsorAd={enable_sponsor_ad}
                    sponsorAdDetails={sponsor_ad_details}
                    sectionSlug={sectionSlug}
                  />
                </div>
                <HeroStory
                  story={secondCollection?.items[0]?.story}
                  showSubheadline={true}
                  showStorySeparator={show_story_separator}
                  showTimestamp={show_timestamp}
                  showReadTime={show_read_time}
                  sectionSlug={sectionSlug}
                />
              </div>
            )
          )}
        </div>
      </div>
      {show_row_separator && <RowSeparator />}
      {show_row_ad_unit_bottom && <DfpComponent adStyleName="ad-slot-size-300x250" id={rowAdBottomDivId} />}
    </div>
  );
};

FourColFiveStoriesWideHero.propTypes = {
  collection: object,
  stories: array,
  extraProp: string,
};

FourColFiveStoriesWideHero.storyLimit = 5;
